export default __webpack_public_path__ + "static/media/AmCham-Primary-Logo-300 w.23cb3c31.png";